import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./EventItem.module.scss";
import { v4 } from "uuid";
import { BackgroundDiv, Label, Span } from '../../../Styleds';
import AppConfig from '../../../AppConfig';
import allStyle from "./../all.module.scss";
import { CustomEventManager } from "../CustomEventManager";
import ImageLoader from "./ImageLoader";
import FriendsIcon from "./FriendsIcon";
const EventItem = ({ eventVo, state = "ready", addModalType,timeType=0, ...props }) => {
    useEffect(()=>{
        const findObj = AppConfig.modeEnum.find(v => v.id === eventVo.events_type);
    },[])
    function getState() {
        const currentDate = new Date();
        const eventEndDate = new Date(eventVo.events_date_end);
        return eventEndDate < currentDate ? "已結束" : "即將出發";
    }
    
    function getEventType() {
        const findObj = AppConfig.modeEnum.find(v => v.id === eventVo.events_type);
        if(findObj)
            return findObj?.label;
        else
        {
            return "";
        }
    }

    return (
        <div key={v4()} className={style.item} {...props} >
            <img src={eventVo.events_photo} />
            <div>
                {
                    timeType === 0 &&
                    <Span size={12} fontFamily="SF Pro">{eventVo.events_date.formatYYYYMMDDHHMM()}</Span>
                }
                {
                    timeType === 1 &&
                    <Span size={12} fontFamily="SF Pro">{eventVo.events_date.formatYYYYMMDD2()}</Span>
                }
                <Span size={17} >{eventVo.events_name}</Span>
                <Span size={13} color="#6C6C6C" fontWeight={400} fontFamily="SF Pro">{`${getEventType()}．${eventVo.rewildingObj.rewilding_name}`}</Span>
                <FriendsIcon users={eventVo.events_participants.latest_tree_user} />
            </div>
            <div className={style.label} ><Span size={12} fontFamily="SF Pro">{getState()}</Span></div>
        </div>
    );
}

export default EventItem;